// @ts-nocheck
import PageLayout from '@components/PageLayout';

import { useSelector } from 'react-redux';

import { RootState } from 'src/store/store';

import WrapperOverview from '@components/styled-UI/WrapperOverview';
import InStoreServicesDetails from '@components/in-store-services/InStoreServicesDetails';

import { getLabelFallback } from '@utils/utils';

const InStoreServices = (): JSX.Element => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const inStoreServicesLabel = getLabelFallback('MYAPPOINTMENTS_IN_STORE_SERVICES_MENU_LABEL');
    const inStoreServicesBackLabel = getLabelFallback(
        'MY_APPOINTMENTS_IN_STORE_SERVICES_BACK_CTA_LABEL'
    );
    return (
        <PageLayout
            data_element_id="AccountSummary_Static"
            hideMenu
            labelMenu={inStoreServicesLabel}
            backLabel={inStoreServicesBackLabel}
        >
            <div
                role="region"
                aria-label="in-store services page title"
                className="in-store-services"
            >
                {!isMobile && (
                    <h2
                        role="region"
                        aria-label="in-store services page title"
                        className="in-store-services-title primary-title"
                    >
                        {inStoreServicesLabel}
                    </h2>
                )}
                <WrapperOverview customStyle="in-store-services-overview">
                    <div
                        role="region"
                        aria-label="in-store services overview title"
                        className="primary-message small align-left overview--in-store-services-message"
                    >
                        {getLabelFallback('MYAPPOINTMENTS_IN_STORE_SERVICES_OVERVIEW_MESSAGE')}
                    </div>
                    <button
                        role="region"
                        aria-label="in-store services overview button"
                        className="primary-button button-size-medium"
                        data-element-id="InStoreServices_Schedule"
                        onClick={() =>
                            window.open(
                                config.callFromComponentToTO.myAppointments.inStoreServices
                                    .scheduleAStoreService,
                                '_parent'
                            )
                        }
                    >
                        {getLabelFallback('MYAPPOINTMENTS_IN_STORE_SERVICES_OVERVIEW_CTA')}
                    </button>
                </WrapperOverview>
                <InStoreServicesDetails />
            </div>
        </PageLayout>
    );
};

export default InStoreServices;
